var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"icon-count-badge"},[(_vm.show)?_c('CountBadge',{staticClass:"icon-count-badge__counter",attrs:{"size":_vm.size,"count":_vm.count,"background-color":_vm.backgroundColor,"text-color":_vm.textColor}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }